import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CheckboxOption = 'heat' | 'cold' | 'rain' | 'fire';

interface MeteorologyAgroOverviewPanelState {
  variable: string | undefined;
  checkboxOptions: CheckboxOption[];
}

const initialState: MeteorologyAgroOverviewPanelState = {
  variable: undefined,
  checkboxOptions: [],
};

export const meteorologyAgroOverviewPanelSlice = createSlice({
  name: 'meteorologyAgroOverviewPanel',
  initialState,
  reducers: {
    setVariable: (state, action: PayloadAction<string | undefined>) => {
      state.variable = action.payload;
    },
    setCheckboxOptions: (state, action: PayloadAction<CheckboxOption[]>) => {
      state.checkboxOptions = action.payload;
    },
  },
});

export const selectMeteorologyAgroOverviewPanelVariable = (state: any) => (
  state.meteorologyAgroOverviewPanel.variable
);

export const selectMeteorologyAgroOverviewPanelCheckboxOptions = (state: any) => (
  state.meteorologyAgroOverviewPanel.checkboxOptions
);

export const {
  setVariable,
  setCheckboxOptions,
} = meteorologyAgroOverviewPanelSlice.actions;

export default meteorologyAgroOverviewPanelSlice.reducer;
